"use strict";

jQuery(document).ready(function ($) {
  $(window).load(function () {
    $("#preloader").fadeOut();
  });
  /*remove active class from current anchor links in menu*/

  var current = $(".menu_main_nav").find(".anchor");
  $(current).removeClass("current-menu-item current_page_item");
  $(".anchor").on('click', function () {
    $("html").removeClass('menu_mobile_open');
    $(".side_wrap").removeClass('open');
    $(".mask").removeClass('show');
  }); //add class to menu  special button

  $(".btn-special").find('a').addClass('sc_button');

  function acceptanceTerms() {
    var rodo = $('#rodo');
    var terms = $('#regulamin');

    if (rodo.length > 0) {
      $("#rodo, #regulamin").change(function () {
        if (rodo.is(':checked') && terms.is(':checked')) {
          $("#register").show();
          $("#paid-form").addClass('hide');
        } else {
          $("#register").hide();
          $("#paid-form").removeClass('hide');
        }
      });
    }
  }

  acceptanceTerms();

  function updateHomeLink() {
    var homelink = $('.home-link a');
    var logo = $('.logo a');

    if (!homelink) {
      return;
    }

    logo.attr("href", homelink.attr('href'));
  }

  updateHomeLink();

  function cartCheckboxTerms() {
    var checks = document.getElementsByName('checkbox_term');
    var checkBoxList = document.querySelector('.cart-terms');
    var sendbtn = document.querySelector('.checkout-button');
    var selectAll = document.querySelector('#selectAll');

    if (checks.length > 0) {
      sendbtn.classList.add('disabled');
    } else {
      return;
    }

    $('#selectAll').click(function () {
      $("input[type=checkbox]").prop("checked", $(this).prop("checked"));
    });

    function allTrue(nodeList) {
      for (var i = 0; i < nodeList.length; i++) {
        if (nodeList[i].checked === false) return false;
      }

      return true;
    }

    function insertInfoText() {
      sendbtn.insertAdjacentHTML('beforebegin', '<p class="required-info">Aby kontynuować zaznacz wszystkie wymagane zgody.</p>');
    }

    insertInfoText();
    checkBoxList.addEventListener('click', function (event) {
      var requireInfo = document.querySelector('.required-info');
      requireInfo.style.display = 'block';
      selectAll.checked = false;
      sendbtn.classList.add('disabled');

      if (allTrue(checks)) {
        sendbtn.classList.remove('disabled');
        selectAll.checked = true;
        requireInfo.style.display = 'none';
      }
    });
  }

  cartCheckboxTerms();
});